require.register("collection/controllers/editCtrl", function(exports, require, module){
  $0
  
});

